import React from "react";

let timer;

function showClass(i, current, numSlides) {
    let result = "";

    if (i === current) {
        result = "in";
    } else if (current === 0 && i === numSlides - 1 || current > 0 && i === current - 1) {
        result = "in-2";
    }
    return result;
}

let ImageSlideshow = React.createClass({
    getInitialState() {
        return {
            current: 0
        };
    },
    propTypes: {
        urls: React.PropTypes.array.isRequired,
        interval: React.PropTypes.number
    },
    componentDidMount(){
        timer = setInterval(this.next, this.props.interval || 4000);
    },
    componentWillUnmount(){
        if (timer) {
            clearInterval(timer);
        }
    },
    next() {
        this.setState({
            current: this.state.current < this.props.urls.length - 1 ? this.state.current + 1 : 0
        });
    },
    render() {
        return (
            <div className={`eo-image-slideshow ${this.props.className || ""}`}>
                {this.props.urls.map((url, i, slides) => {
                    return (
                        <div key={i} style={{backgroundImage: `url(${url})`}}className={["eo-image-slideshow-image", showClass(i, this.state.current, slides.length)].join(" ")}></div>
                    );
                })}
            </div>
        );
    }
});

export default ImageSlideshow;



/** WEBPACK FOOTER **
 ** ./app/views/components/ImageSlideshow.js
 **/